





































/* eslint-disable */
// @ts-nocheck
import { Vue, Component, Prop } from 'vue-property-decorator'
// import TcVod from 'vod-js-sdk-v6'
import { getVideoSignature } from '@/services/get-token'
import { uuid4 } from '@/utils/mUtil'
import Axios from 'axios'
import { GenerateSnapshotNew } from '@/services/urls'
import TcVod from 'vod-js-sdk-v6' // 老的腾讯云上传服务
import TxCOS from 'cos-js-sdk-v5'
import AliCos from 'ali-oss'
import HwObsClient from 'esdk-obs-browserjs'
import utils from '@/utils/utils'

const win = window as any

@Component({})
export default class UploadVideo extends Vue {
  $toast: any
  public $refs!: { uploadEl: HTMLFormElement }
  content = ''
  vrsId = 0
  tokenFail = false
  vInfo?: any = null
  ruuid = ''
  showSpeed = true
  @Prop() formData?: any

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  handleUpload(event: Event) {
    const target: HTMLInputElement = event.target as HTMLInputElement
    const files: FileList | null = target.files
    if (files) {
      const file = files[0]
      if (!file.type.includes('video')) {
        this.$refs.uploadEl.value = ''
        return this.$toast('非视频类型,请重新选择')
      }
      this.vInfo = null
      win.VIDEO_FILE = null
      this.content = file.name
      this.ruuid = uuid4()
      this.getVideoToken()
      this.browse(file, event.currentTarget as HTMLInputElement)
    }
  }

  Rename(file: File) {
    const tempArr: Array<any> = file.name.split('.'),
      patternType: string = tempArr.pop(),
      newName: string = tempArr.join('.'),
      newFile: File = new File(
        [file],
        newName + '_' + uuid4() + '.' + patternType
      )

    return newFile
  }

  async getVideoToken() {
    const { uuid, ticket, nickname } = this.userInfoInapp

    if (!uuid || !ticket) {
      return this.$toast('未登录')
    }
    try {
      const response: API.APIRespose = await getVideoSignature({
        uuid,
        ticket,
        biz: 3,
        title: '',
        content: this.content,
        randStr: this.ruuid,
        nickname,
      })

      if (!response || !response.data) {
        this.tokenFail = true
        return this.$toast(response.msg || '上传获取token失败')
      }
      this.tokenFail = false
      const { videoId, signature } = response.data
      this.vrsId = videoId

      return signature
    } catch (err) {
      this.$toast(err)
    }
  }

  async browse(file: File, el?: HTMLInputElement | undefined) {
    const tcVod = new TcVod({
        getSignature: this.getVideoToken,
      }),
      newFile = this.Rename(file),
      uploader = tcVod.upload({
        mediaFile: newFile,
      })
    console.log(newFile)

    uploader.on('media_progress', (info: any) => {
      this.tokenFail = false
      this.vInfo = {
        speed:
          info.speed / 1000 / 1000 < 1
            ? (info.speed / 1000).toFixed(0) + 'kb/S'
            : (info.speed / 1000 / 1000).toFixed(0) + 'MB/S',
        percent: info.percent,
        finsh: false,
        status: 0,
        uploadlog: '',
        vrsId: this.vrsId,
      }
    })

    uploader
      .done()
      .then(doneResult => {
        const result = {
          finsh: true,
          status: 1,
          uploadlog: JSON.stringify(doneResult),
        }

        this.vInfo = Object.assign(this.vInfo, result)

        if (this.formData) {
          this.formData.video = this.vInfo
        }

        // 视频上传完成后，调取接口获取自动封面
        this.getDefaultCover(doneResult.video.url, 0.03).then(res => {
          this.$emit('getCoverSucc', res)
        })

        this.getDefaultCover(doneResult.video.url, 3.03).then(res => {
          this.$emit('getCoverSucc', res)
        })

        this.getDefaultCover(doneResult.video.url, 9.03).then(res => {
          this.$emit('getCoverSucc', res)
        })
      })
      .catch((err: any) => {
        this.$toast(err + '视频上传失败,请重新上传')
        const result = {
          finsh: true,
          status: 2,
        }
        if (this.vInfo) {
          this.vInfo = Object.assign(this.vInfo, result)
        } else {
          this.tokenFail = true
        }
      })
    if (el) {
      el.value = ''
    }
  }

  getDefaultCover(videoUrl: string, time: number) {
    const { uuid, ticket } = this.userInfoInapp
    return new Promise((resolve, reject) => {
      Axios({
        url: GenerateSnapshotNew,
        method: 'get',
        params: {
          id: videoUrl,
          fileUrl: videoUrl,
          coverTime: time,
          width: 750,
          height: 422,
          uploader: uuid,
          token: ticket,
          plat: 2003,
          time:time
        },
      })
        .then(res => {
          if (res.data.code === 200) {
            resolve(res.data.data)
          } else {
            //this.$toast('视频封面自动获取失败，请手动选择')
            resolve('')
          }
        })
        .catch(function(error) {
          reject(error)
        })
    })
  }
  // eslint-disable-next-line
  async getUploadToken(videoFile: any) {
    let fileSize = videoFile.size
    let fileSubfix = videoFile.name.split('.')[1]
    let fileBase64Front64 = (await utils.getFileBase64(videoFile)).data
    let fileMd5 = await utils.getFileMd5(videoFile, 2097152)
    let signRequstData = {
      base64: fileBase64Front64,
      fileSize: fileSize,
      fileMd5: fileMd5,
      fileSubfix: fileSubfix,
    }
    let res = await getVideoSignature(signRequstData)

    if (res && res.code == 200) {
      this.formData.fileCloudId = res.data.keyInfo.idstr
      let fileObj = videoFile
      if (videoFile.raw) fileObj = videoFile.raw
      this.formData.fileName = videoFile.name
      fileObj.fileName = videoFile.name
      // 指定上传云： 0-自适应, 10-本地存储，11-大鱼存储，12-自建ceph；20-云存储，21-阿里云OSS，22-腾讯云COS，23-华为云OBS，24-AWS S3
      if (res.data.bucketInfo.cloud === 22) {
        this.createTcCloundUploader(fileObj, res.data)
      }
      if (res.data.bucketInfo.cloud === 21) {
        this.createAliCloundUploader(fileObj, res.data)
      }
      if (res.data.bucketInfo.cloud === 23) {
        this.createHwCloundUploader(fileObj, res.data)
      }
    } else {
      this.tokenFail = true
      let msg = res.msg
      this.$toast('上传获取token失败' + msg)
    }
  }

  // 腾讯云COS
  createTcCloundUploader(file: any, stsDataObj: any) {
    const self = this,
      videoFile = file,
      cosTcVod = new TxCOS({
         
        getAuthorization: function(options, callback) {
          callback({
            TmpSecretId: stsDataObj.stsToken.accessKeyId,
            TmpSecretKey: stsDataObj.stsToken.accessKeySecret,
            SecurityToken: stsDataObj.stsToken.securityToken,
            ExpiredTime:
              new Date(stsDataObj.stsToken.expiration).getTime() / 1000,
          })
        },
        ProgressInterval: 1000,
      })

    const tcVodObj: any = cosTcVod.uploadFile({
      Bucket: stsDataObj.bucketInfo.bucket,
      Region: stsDataObj.bucketInfo.region,
      Key: stsDataObj.keyInfo.key,
      StorageClass: 'STANDARD',
      Body: videoFile,
      onProgress: function(progressData) {
        onProgress(progressData)
      },
      onFileFinish: function(err, data, options) {
        console.log(data)
        onFileSucc(data, stsDataObj, file)
      },
    })

    const onProgress = (info: any) => {
      this.tokenFail = false
      console.log('video upload on progress ....', info)

      this.vInfo = {
        speed:
          info.speed / 1000 / 1000 < 1
            ? (info.speed / 1000).toFixed(0) + 'kb/S'
            : (info.speed / 1000 / 1000).toFixed(0) + 'MB/S',
        percent: info.percent,
        finsh: false,
        status: 0,
        uploadlog: '',
        vrsId: this.vrsId,
      }
    }

    const onFileSucc = (res: any, stsDataObj: any, file: any) => {
      const result = {
        finsh: true,
        status: 1,
        uploadlog: JSON.stringify(res),
      }
      this.vInfo = Object.assign(this.vInfo, result)
      if (this.formData) {
        this.formData.video = this.vInfo
      }
      this.getCover(stsDataObj.keyInfo.idstr)
    }
  }

  // 阿里COS
  createAliCloundUploader(file: any, stsDataObj: any) {
    const self = this,
      videoFile = file,
      ossClientAli = new AliCos({
        accessKeyId: stsDataObj.stsToken.accessKeyId,
        accessKeySecret: stsDataObj.stsToken.accessKeySecret,
        stsToken: stsDataObj.stsToken.securityToken,
        endpoint: stsDataObj.bucketInfo.endpoint,
        bucket: stsDataObj.bucketInfo.bucket
      })
 
    // 监听进度事件
    ossClientAli
      .multipartUpload(stsDataObj.keyInfo.key, videoFile, {
        progress: function(percentage, checkpoint, res) {
          console.log(res)
          onProgress({ percent: percentage })
        }
      })
      .then(function(result) {
        onFileSucc(result, stsDataObj, file)
      })
      .catch(function(err) {
        console.error('Upload error:', err)
      })
 
    const onProgress = (info: any) =>{
      console.log(info.percent)
      this.showSpeed = false
      this.vInfo = {
        speed: 0,
        percent: Math.round(info.percent * 100) / 100,
        finsh: false,
        status: 0,
        uploadlog: '',
        vrsId: this.vrsId,
      }
    }

    const onFileSucc = (res: any, stsDataObj: any, file: any) => {
      const result = {
        finsh: true,
        status: 1,
        uploadlog: JSON.stringify(res),
      }
      this.vInfo = Object.assign(this.vInfo, result)
      if (this.formData) {
        this.formData.video = this.vInfo
      }
      this.getCover(stsDataObj.keyInfo.idstr)
    }
    
  }

    // 华为云
  createHwCloundUploader(file: any, stsDataObj: any) {
    const self = this,
      videoFile = file,
      obsClient = new HwObsClient({
        access_key_id: stsDataObj.stsToken.accessKeyId,
        secret_access_key: stsDataObj.stsToken.accessKeySecret,
        security_token: stsDataObj.stsToken.securityToken,
        server: stsDataObj.bucketInfo.endpoint,
        timeout: 300
      })
 
    var processCallback = function(transferredAmount, totalAmount, totalSeconds) {
      // 获取上传平均速率（M/S）
      console.log((transferredAmount * 1.0) / totalSeconds / 1024 / 1000)
      // 获取上传进度百分比
      // console.log((transferredAmount * 100.0) / totalAmount)

      console.log(transferredAmount, totalAmount, totalSeconds)
      onProgress(transferredAmount, totalAmount, totalSeconds)
    }

    // 监听进度事件
    obsClient
      .putObject({
        Bucket: stsDataObj.bucketInfo.bucket,
        Key: stsDataObj.keyInfo.key,
        SourceFile: videoFile,
        ProgressCallback: processCallback
      })
      .then(function(result:any) {
        console.log('Upload success: ', result)
        onFileSucc(result, stsDataObj, file)
      })
      .catch(function(err:any) {
        console.error('Upload failed: ', err)
      })

 

    const onProgress = (transferredAmount:any, totalAmount:any, totalSeconds:any) => {
      console.log(  (transferredAmount / totalAmount).toFixed(2) )
      this.showSpeed = false
      this.vInfo = {
        speed: 0,
        percent: (transferredAmount / totalAmount).toFixed(2),
        finsh: false,
        status: 0,
        uploadlog: '',
        vrsId: this.vrsId,
      }
       
    }

    const onFileSucc = (res:any, stsDataObj:any, file:any) => {
      const result = {
        finsh: true,
        status: 1,
        uploadlog: JSON.stringify(res),
      }
      this.vInfo = Object.assign(this.vInfo, result)
      if (this.formData) {
        this.formData.video = this.vInfo
      }
      this.getCover(stsDataObj.keyInfo.idstr)
    }

  }


  getCover(idstr:string) {
    this.getDefaultCover(idstr, 0.03).then(res => {
      this.$emit('getCoverSucc', res)
    })

    this.getDefaultCover(idstr, 3.03).then(res => {
      this.$emit('getCoverSucc', res)
    })

    this.getDefaultCover(idstr, 9.03).then(res => {
      this.$emit('getCoverSucc', res)
    })
  }
  mounted() {
    if (!win.VIDEO_FILE && !location.href.includes('debug')) {
      this.$router.replace({ path: '/' })
    } else {
      let file = win.VIDEO_FILE
      if (file.raw) file = file.raw
      this.vInfo = null
      this.content = file.name
      this.ruuid = uuid4()
      this.getUploadToken(file)
    }
  }
}
